<template>
    <loading-indicator v-if="loading || !correctionData"/>
    <form v-else ref="form">
        <div class="row">
            <div class="col-md-12">
                <form-row label="Mitarbeiter">
                    <person-box-employee :id="correctionData.employee_id"/>
                </form-row>
                <form-row label="Begründung:">
                    <div class="label-padding">{{correctionData.message}}</div>
                </form-row>
                <div v-if="0 === correctionData.type" class="row">
                    <div class="col-12">
                        <form-row label="Art:">
                            <form-input model-value="Korrektur eines Eintrags" aria-label="Aktion" disabled/>
                        </form-row>
                    </div>

                    <div class="col-md-6">
                        <form-row label="Alte Zeit:">
                            <div class="row">
                                <div class="col-md-6">
                                    <form-input :model-value="dateHelper('d.m.Y', correctionData.old_stamp)" aria-label="Alte Zeit: Datum" disabled/>
                                </div>
                                <div class="col-md-6">
                                    <form-input :model-value="dateHelper('H:i', correctionData.old_stamp)" aria-label="Alte Zeit: Uhrzeit" disabled/>
                                </div>
                            </div>
                        </form-row>
                    </div>

                    <div class="col-md-6">
                        <form-row label="Neue Zeit:">
                            <div class="row">
                                <div class="col-md-6">
                                    <form-input :model-value="dateHelper('d.m.Y', correctionData.new_stamp)" aria-label="Neue Zeit: Datum" disabled/>
                                </div>
                                <div class="col-md-6">
                                    <form-input :model-value="dateHelper('H:i', correctionData.new_stamp)" aria-label="Neue Zeit: Uhrzeit" disabled/>
                                </div>
                            </div>
                        </form-row>
                    </div>
                </div>
                <div v-else-if="1 === correctionData.type" class="row">
                    <div class="col-12">
                        <form-row label="Art:">
                            <form-input model-value="Eintragung einer Pause" aria-label="Aktion" disabled/>
                        </form-row>
                    </div>

                    <div class="col-md-6">
                        <form-row label="Pausenbeginn:">
                            <div class="row">
                                <div class="col-md-6">
                                    <form-input :model-value="dateHelper('d.m.Y', correctionData.newBreakBeginStamp)" aria-label="Pausenbeginn: Datum" disabled/>
                                </div>
                                <div class="col-md-6">
                                    <form-input :model-value="dateHelper('H:i', correctionData.newBreakBeginStamp)" aria-label="Pausenbeginn: Uhrzeit" disabled/>
                                </div>
                            </div>
                        </form-row>
                    </div>

                    <div class="col-md-6">
                        <form-row label="Pausenende:">
                            <div class="row">
                                <div class="col-md-6">
                                    <form-input :model-value="dateHelper('d.m.Y', correctionData.newBreakEndStamp)" aria-label="Pausenende: Datum" disabled/>
                                </div>
                                <div class="col-md-6">
                                    <form-input :model-value="dateHelper('H:i', correctionData.newBreakEndStamp)" aria-label="Pausenende: Uhrzeit" disabled/>
                                </div>
                            </div>
                        </form-row>
                    </div>
                </div>
                <div v-else-if="2 === correctionData.type" class="row">
                    <div class="col-12">
                        <form-row label="Art:">
                            <form-input model-value="Löschung einer Pause" aria-label="Aktion" disabled/>
                        </form-row>
                    </div>

                    <div class="col-md-6">
                        <form-row label="Pausenbeginn:">
                            <div class="row">
                                <div class="col-md-6">
                                    <form-input :model-value="dateHelper('d.m.Y', correctionData.beginStamp)" aria-label="Pausenbeginn: Datum" disabled/>
                                </div>
                                <div class="col-md-6">
                                    <form-input :model-value="dateHelper('H:i', correctionData.beginStamp)" aria-label="Pausenbeginn: Uhrzeit" disabled/>
                                </div>
                            </div>
                        </form-row>
                    </div>

                    <div class="col-md-6">
                        <form-row label="Pausenende:">
                            <div class="row">
                                <div class="col-md-6">
                                    <form-input :model-value="correctionData.endStamp ? dateHelper('d.m.Y', correctionData.endStamp) : '--:--'" aria-label="Pausenende: Datum" disabled/>
                                </div>
                                <div class="col-md-6">
                                    <form-input :model-value="correctionData.endStamp ? dateHelper('H:i', correctionData.endStamp) : '--:--'" aria-label="Pausenende: Uhrzeit" disabled/>
                                </div>
                            </div>
                        </form-row>
                    </div>
                </div>
                <div v-else-if="3 === correctionData.type">
                    <form-row label="Art:">
                        <form-input model-value="Hinterlegung der Arbeitszeiten" aria-label="Aktion" disabled/>
                    </form-row>

                    <form-row label="Datum">
                        <form-input :model-value="dateHelper('d.m.Y', correctionData.begin)" aria-label="Datum" disabled/>
                    </form-row>

                    <div class="row">
                        <div class="col-md-6">
                            <form-row label="Arbeitsbeginn:">
                                <form-input :model-value="dateHelper('H:i', correctionData.begin)" aria-label="Arbeitsbeginn: Uhrzeit" disabled/>
                            </form-row>
                        </div>

                        <div class="col-md-6">
                            <form-row label="Arbeitsende:">
                                <form-input :model-value="dateHelper('H:i', correctionData.end)" aria-label="Arbeitsende: Uhrzeit" disabled/>
                            </form-row>
                        </div>
                    </div>

                    <form-row v-if="correctionData.breaks.length" label="Pausen">
                        <div v-for="correctionBreak in correctionData.breaks" class="row margin-bottom-10">
                            <div class="col-md-6">
                                <form-row label="Pausenbeginn:">
                                    <form-input :model-value="dateHelper('H:i', correctionBreak.begin)" aria-label="Pausenbeginn: Uhrzeit" disabled/>
                                </form-row>
                            </div>

                            <div class="col-md-6">
                                <form-row label="Pausenende:">
                                    <form-input :model-value="dateHelper('H:i', correctionBreak.end)" aria-label="Pausenende: Uhrzeit" disabled/>
                                </form-row>
                            </div>
                        </div>
                    </form-row>
                </div>

                <form-row v-if="projectInfo" label="Hinweis:">
                    <div class="label-padding message-content" v-html="projectInfo"/>
                </form-row>

                <form-row label="Begründung (optional):">
                    <form-textarea name="description" class="textarea-vertical"/>
                </form-row>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <evaluation-view :employee="employee" :week="week" table-only/>
            </div>
        </div>
    </form>
</template>

<script lang="ts">
    import {getWorkDaysAndHoursStringByWorkDays} from '@/library/modules/time-tracker/time-tracker';
    import {Component, Prop, Vue} from 'vue-facing-decorator';
    import FormInput from '../../../components/form/FormInput.vue';
    import FormRow from '../../../components/form/FormRow.vue';
    import FormTextarea from '../../../components/form/FormTextarea.vue';
    import LoadingIndicator from '../../../components/LoadingIndicator.vue';
    import PersonBoxEmployee from '../../../components/PersonBoxEmployee.vue';
    import {formSubmit, getFormData, parseFormData} from '../../../library/form';
    import EditBlockHandler from '../../../library/intranet/editBlockHandler';
    import {popupDefaultCancelButton} from '../../../library/popup';
    import TopMessageHandler from '../../../library/topMessageHandler';
    import {errorHandler} from '../../../utils/portuna';
    import dateHelper from '../../../utils/portuna/dateHelper';
    import EvaluationView from '../evaluation/EvaluationView.vue';

    @Component({
        name: 'CorrectionEditPopup',
        components: {
            PersonBoxEmployee,
            LoadingIndicator,
            EvaluationView,
            FormInput,
            FormTextarea,
            FormRow
        },
        methods: {
            dateHelper
        },
        emits: ['setButtons', 'saved'],
    })
    export default class CorrectionEditPopup extends Vue
    {
        readonly $refs: {
            form: HTMLFormElement,
        };

        @Prop({
            type: Number,
            required: true,
        }) id: number;

        @Prop({
            type: Number,
            required: true,
        }) employee: number;

        get buttons(): PopupButton[]
        {
            return [
                popupDefaultCancelButton,
                {
                    type: 'success',
                    title: 'Annehmen',
                    icon: 'check',
                    cmd: () => this.edit(true),
                },
                {
                    type: 'danger',
                    title: 'Ablehnen',
                    icon: 'clear',
                    cmd: () => this.edit(false),
                },
            ];
        }

        correctionData = null as Nullable<CorrectionEditEntry>;

        projectInfo: string = '';

        workDays = {} as Record<TDayNames, Nullable<{ start: string; end: string; }>>;

        calculateNonWorkdays: boolean = false;

        calculateBeforeWorkStart: boolean = false;

        calculateAfterWorkEnd: boolean = false;

        allowWorkOutsideWorkTime: boolean = false;

        loading: boolean = true;

        get workDaysList()
        {
            return getWorkDaysAndHoursStringByWorkDays(this.workDays);
        }

        get week()
        {
            let date: string|Date = new Date();

            if(this.correctionData)
            {
                if(0 === this.correctionData.type && this.correctionData.old_stamp)
                {
                    date = this.correctionData.old_stamp;
                }
                else if(1 === this.correctionData.type && this.correctionData.newBreakBeginStamp)
                {
                    date = this.correctionData.newBreakBeginStamp;
                }
                else if(2 === this.correctionData.type && this.correctionData.beginStamp)
                {
                    date = this.correctionData.beginStamp;
                }
                else if(3 === this.correctionData.type && this.correctionData.begin)
                {
                    date = this.correctionData.begin;
                }
            }

            return dateHelper('Y-m-d', date);
        }

        created()
        {
            this.emitter.emit('setButtons', this.buttons);
            this.$emit('setButtons', this.buttons);
            this.fetch();
        }

        unmounted()
        {
            EditBlockHandler.destroy('time-tracker', 'correction');
        }

        fetch()
        {
            this.loading = true;

            this.axios.get(`/employee/time-tracker/correction/edit/id/${this.id}`)
            .then(({data: {data: r}}) =>
            {
                this.$store.dispatch('form/setFilter', r.filter);
                this.correctionData           = r.data;
                this.projectInfo              = r.projectInfo;
                this.workDays                 = r.work_days;
                this.allowWorkOutsideWorkTime = r.allow_work_outside_work_time_current;
                // TODO.colombu: remove unused settings
                this.calculateNonWorkdays     = r.calculate_non_workdays;
                this.calculateBeforeWorkStart = r.calculate_before_work_start;
                this.calculateAfterWorkEnd    = r.calculate_after_work_end;
            })
            .catch(error =>
            {
                errorHandler(error);
                this.emitter.emit('close');
            })
            .finally(() =>
            {
                this.loading = false;
                this.emitter.emit('lazy-load-focus');
            });
        }

        edit(apply: boolean)
        {
            let formData = getFormData(this.$refs.form);

            let url = `/employee/time-tracker/correction/edit/id/${this.id}${apply ? '' : '/reject/1'}`;
            formSubmit(url, parseFormData(formData))
            .then(() => {
                TopMessageHandler.success(`Sie haben die Korrektur erfolgreich ${apply ? 'angenommen' : 'abgelehnt'}.` );
                this.emitter.emit('emit', {event: 'saved'});
                this.$emit('saved');
            })
            .catch(() => {
                this.emitter.emit('close');
            });
        }
    }
</script>